import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoExportDutyAdjust extends Component {

    render() {
        const { exportDues } = this.props;
        const summary = getTitleSummary(exportDues)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Экспортная пошлина. Дополнительные соглашения'],
                    rows: summary
                }}
                expanded={(exportDues.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Ставка',
                        'Вид',
                        'Страна назначения',
                        'Комментарий',
                        'Нормативный документ'
                    ],
                    rows: exportDues.map(({ to_date = null, dest_country = '', dutyadjusttype = null, hint = '', description = '', order, order_date, orders_info }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        hint,
                        dutyadjusttype !== null ? dutyadjusttype.name : '',
                        dest_country,
                        description,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    return items.length > 0 ? items.slice(0, 1).map(({ hint = '' }) =>
        ([`${hint}` + (items.length > 1 ? '' : '')])) : null
}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoExportDutyAdjust.js